/**
 * SASS
 */
import "../sass/frontend.scss";
/**
 * JS IMPORT
 */
import { allSwiper } from "./components/swiper.js";
import { initLightGallery } from "./components/lightgallery.js";
import { gmapGilson } from "./components/gmap.js";
import { formComplaint } from "./components/form-complaint.js";
import { showCategoryList } from "./components/category-list.js";
import { showSearchbar } from "./components/searchbar.js";
import QuestionRoom from "./components/questionroom.js";
import FiltreActivites from "./components/selector-activity.js";
/**
 * BODYSCROLLLOCK
 */

const initEs6 = () => {
  allSwiper();
  initLightGallery();
  // gmapGilson();
  showSearchbar();
  showCategoryList();
};


jQuery(document).ready(function ($) {


  // $('#menu-langues').prependTo('.searchbar > .secondary-container');

  function evenOdd() {
    $("#main > section:not(.block-header):not(.block-bottom)").each(function (
      index
    ) {
      if (index % 2 == 0) {
        $(this).addClass("bg-grey");
      }
    });
  }

  function showVideo() {
    $(".youtube-thumbnail")
      .parent()
      .on("click", function () {
        $(this).addClass("hidden");
        const videoSrc = $(this).siblings(".youtube-video").attr("src");
        const cloneVideo = $(this).siblings(".youtube-video").clone();
        cloneVideo.attr("src", videoSrc + "&autoplay=1");
        $(this).siblings(".youtube-video").replaceWith(cloneVideo);
        $(this).siblings(".youtube-video").removeClass("hidden");
      });
  }

  function toNextSection() {
    $("#next-section").click(function () {
      const blockToScrollTo = $(".block-header").next();
      $("html, body").animate(
        {
          scrollTop: blockToScrollTo.offset().top - 50,
        },
        1000
      );
    });
  }

  function showHeaderScroll() {
    let lastScrollTop = 0;
    const header = document.querySelector("#header");
    const headerHeight = header.offsetHeight;
  
    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop < lastScrollTop || scrollTop <= headerHeight) {
        // Scroll up or at the top of the page
        header.classList.add("header-show");
      } else {
        // Scroll down
        header.classList.remove("header-show");
      }
      lastScrollTop = scrollTop;
    }
  
    window.addEventListener("scroll", handleScroll);
  }

  function expandCollapseElement() {
    $(".expandCollapseAction").each(function (i, val) {
      let oldText = $(this).text();
      $(this).click(function (e) {
        e.stopPropagation();
        let nextEl = $(this).next();
        let spanVal = $(this).children("span");

        $(this)
          .parents()
          .each(function (i, val) {
            if (
              $(this).hasClass("block-container") &&
              $(this).hasClass("centered")
            ) {
              if (spanVal.text() == "Masquer la suite") spanVal.text(oldText);
              else spanVal.text("Masquer la suite");
            }
          });
        $(this).toggleClass("opened");

        nextEl.slideToggle();
      });
    });
  }

  function mobileMenuOpen() {
    $(".site-menu-toggle").click(function () {

      $("#header").toggleClass("menu-is-open");
      $(".burger").toggleClass("cross");
      $(".searchbar").removeClass("show-mobile");
      $(".search-icon").removeClass("d-none");
    });
  }
  function bodyScrollFix() {
    // 1. Import the functions
    const disableBodyScroll = bodyScrollLock.disableBodyScroll;
    const enableBodyScroll = bodyScrollLock.enableBodyScroll;

    // 2. Get a target element that you want to persist scrolling for (such as a modal/lightbox/flyout/nav).
    const targetElement = document.querySelector("#site-menu .menu");

    //3. Toggle body scroll in some event handler when target element is displayed
    $(".site-menu-toggle").click(function () {
      if ($("#header").hasClass("menu-is-open")) {
        // 3.1 disable body scroll after showing the target element
        disableBodyScroll(targetElement);
      } else {
        // 4. enable body scroll after hiding the target element
        enableBodyScroll(targetElement);
      }
    });
  }

  // Open mobile submenu

  function mobileSubmenuOpen() {
    $("#site-menu .menu-item-has-children > i").click(function () {
      $(this).parent().siblings(".submenu-open").find(".sub-menu").slideUp(50); // close all submenus which are open at the same level
      $(this)
        .parent()
        .siblings(".submenu-open")
        .find(".angle-up")
        .removeClass("angle-up");
      $(this).parent().siblings(".submenu-open").removeClass("submenu-open");

      $(this).toggleClass("angle-up");
      $(this).parent().toggleClass("submenu-open");

      $(this).next(".sub-menu").slideToggle(50); // toggle submenu opening
    });

    if (window.innerWidth > 1200) {
      $(
        "#site-menu .menu-item-has-children > a, #site-menu .menu-item-has-children > i"
      ).hover(function () {
        $(this)
          .parent()
          .siblings(".submenu-open")
          .find(".sub-menu")
          .slideUp(50); // close all submenus which are open at the same level
        $(this)
          .parent()
          .siblings(".submenu-open")
          .find(".angle-up")
          .removeClass("angle-up");
        $(this).parent().siblings(".submenu-open").removeClass("submenu-open");

        $(this).siblings(".open-children").addClass("angle-up");
        $(this).parent().addClass("submenu-open");

        $(this).siblings(".sub-menu").slideDown(50); // toggle submenu opening
      });
    }
  }

  // Toggle class on active page menu

  //show active page
  function menuActive() {
    const url = window.location.href.substr(
      window.location.href.lastIndexOf("/") + 1
    );
    $("#site-menu .menu .menu-item.level-1 >a").each(function () {
      if ($(this).attr("href") === url) $(this).parent().addClass("active");
    });
  }

  function expandCollapse() {
    $(".collapse-header").each(function (i, val) {
      $(this).click(function (e) {
        e.stopPropagation();
        let nextEl = $(this).parent().next();
        nextEl.slideToggle();
      });
    });
  }

  function init() {
    const questionRoom = new QuestionRoom(questionroom, _paq);
    const selectoractivity = new FiltreActivites();
    expandCollapse();
    menuActive();
    expandCollapseElement();
    // scrollToCF7Message();
    mobileMenuOpen();
    bodyScrollFix();
    mobileSubmenuOpen();
    menuActive();
    // toNextSection();
    showVideo();
    evenOdd();
    showHeaderScroll();
  }

  init();
});
initEs6();
